import React, {useCallback, useEffect} from "react"
import {Link, useSearchParams} from "react-router-dom"
import {getTimeFromNow} from "../../../functions/time"
import {IssueMeta} from "../../../models/IssueDB.model"
import styles from "./index.module.scss"

interface IssueTableProps {
  issues: IssueMeta[]
}

export const IssueTable = (props: IssueTableProps) => {
  const {issues} = props
  const [searchParams, setSearchParams] = useSearchParams()
  const issueType = searchParams.get("type")

  const onClickOpen = useCallback(() => {
    setSearchParams({type: "open"})
  }, [setSearchParams])

  const onClickClosed = useCallback(() => {
    setSearchParams({type: "closed"})
  }, [setSearchParams])

  useEffect(() => {
    if (!issueType) {
      setSearchParams({type: "open"})
    }
  }, [issueType, setSearchParams])

  if (issueType !== "open" && issueType !== "closed") {
    return null
  }
  const openCnt = issues.filter(r => r.status === "open").length
  const closedCnt = issues.filter(r => r.status === "closed").length
  const displayIssues = issues.filter(r => r.status === issueType)
  const isOpen = issueType === "open"

  return (
    <div className={styles.RequestTbl}>
      <div className={styles.RequestTblHeader}>
        <button className={isOpen ? styles.ActiveButton : styles.InactiveButton}
                onClick={onClickOpen}
        >
          OPEN ({openCnt})
        </button>
        <button className={!isOpen ? styles.ActiveButton : styles.InactiveButton}
                onClick={onClickClosed}
        >
          CLOSED ({closedCnt})
        </button>
      </div>

      {
        displayIssues.sort((a, b) => b.createAt - a.createAt).map(r => {
          return (
            <Link className={styles.RequestTblRow}
                  to={`./${r.id}`}
                  key={r.id}
            >
              <div className={styles.RequestMeta}>
                <div className={styles.RequestSummary}>
                  {r.title}
                </div>
                <div className={styles.RequestDetails}>
                  #{r.id.slice(0, 8)} - Created {getTimeFromNow(r.createAt, true)} by @{r.authorName}
                </div>
              </div>
            </Link>
          )
        })
      }
    </div>
  )
}
